import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SharedService } from '../Services/shared.service';
import { APIConfigMapping, HTTPAPIConfig, VlDataService, VlHttpService, isNullOrUndefined,LogoutService } from 'shared-library';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'lib-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnDestroy {

  applicationId!:string;
  applicationName!:string;
  imageSrc!:any;
  userInfo: any;
  destroy$:Subject<void> = new Subject<void>
 constructor(private dataService: VlDataService,
    private httpService: VlHttpService,private route: ActivatedRoute,
    private router: Router,private sharedService:SharedService,
    private logoutService:LogoutService
    )
  {
    this.subscribeEvents();
    this.sharedService.applicationDataObj$.pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
      if(data)
      {
        this.getApplicationById(this.applicationId);
      }
    })
    this.userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo') as string) : null;
  }

  subscribeEvents(){
    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((params: Params) => {
      this.applicationId=params?.['id']
    })
  }



  getApplicationById(id:string)
  {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_APPLICATION']);
    let customerMetaRaw: any = localStorage.getItem('metaInfo');
    apiConfig.postData = {
      id: id
    }
     apiConfig.options = {
      params: {
        "is_web":"true",
      }
    }
    if(!isNullOrUndefined(this.sharedService.getApplicationDataEntire())){
      let data = this.sharedService.getApplicationDataEntire()
      this.sharedService.setApplicationDataById(data)
      this.applicationName = data.application_name;
      let image = 'data:image/png;base64,';
      image = image+data.logo;
      this.imageSrc = image;
    }else{
    this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$)).subscribe({
      next: (data: any) => {
        this.sharedService.setApplicationDataById(data)
        this.sharedService.setApplicationDataEntire(data)
        this.applicationName = data.application_name;
        let image = 'data:image/png;base64,';
        image = image+data.logo;
        this.imageSrc = image;
      },
      error: (err: any) => {
      }
    })}
  }

  redirectToHome() {
    this.sharedService.clearBreadcrumb();
    this.router.navigate(['home']);
  }

  redirectBack()
  {
    let projectId = localStorage.getItem("projectId")
    let projectName = localStorage.getItem("projectName")
    const currentParams = { ...this.route.snapshot.queryParams };
    currentParams['id'] = projectId;
    currentParams["projectName"] = projectName;
    this.router.navigate(['home','applications'], {
      queryParams: {
        "id":projectId,
        "projectName":projectName
      }
    });
  }


  
  async logout() {
   this.logoutService.logoutUser();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
